import React, { useContext } from 'react'
import './EventEdit.css'

import { SPContext } from '../../SPContext'
import { UncontrolledTooltip } from 'reactstrap'

function EventEdit({ item_event }) {
  const { handleOpenEventModal } = useContext(SPContext)

  const eventEditPost = (e, event_id) => {
    handleOpenEventModal(e, 'editing', event_id)
  }

  if (item_event) {
    return (
      <>
        <UncontrolledTooltip
          placement="bottom"
          target={'event-edit-' + item_event.event_id}
        >
          {(item_event &&
            item_event.event_FK_event_status_id === '5' &&
            'Edit closed/expired event') ||
            'Edit event'}
        </UncontrolledTooltip>

        <div
          id={'event-edit-' + item_event.event_id}
          className={
            'sp-event-edit-edit-icon' +
            ((item_event &&
              item_event.event_FK_event_status_id === '5' &&
              ' sp-event-edit-edit-icon-event-closed') ||
              '')
          }
          onClick={e => eventEditPost(e, item_event.event_id)}
        >
          <i className="sp-event-edit-edit-icon far fa-edit" />
        </div>
      </>
    )
  }
  return null
}

export default EventEdit
